import axios from 'axios'

// One client for every /api/v1/affiliates call (affiliate tab and admin pages).
// Call the collection itself as '' (not '/'): Vercel only forwards /api/... without a trailing slash, and
// answers /api/v1/affiliates/ with the dashboard's index.html.
export const affiliateApi = axios.create({ baseURL: '/api/v1/affiliates', withCredentials: true })

// Every endpoint answers JSON (or nothing, for a 204). Anything else, such as the dashboard's own HTML from a
// misrouted path, is turned into an error so pages show a message instead of reading fields off a string.
affiliateApi.interceptors.response.use((response) => {
    const type = String(response.headers['content-type'] || '')
    if (response.status !== 204 && !type.includes('application/json')) {
        return Promise.reject(new Error(`Unexpected response from ${response.config.url || 'the API'}`))
    }
    return response
})

export const apiGet = <T>(url: string, params?: Record<string, unknown>) =>
    affiliateApi.get<T>(url, { params }).then((r) => r.data)

export const apiPost = <T>(url: string, body: unknown = {}) => affiliateApi.post<T>(url, body).then((r) => r.data)

export const apiPatch = <T>(url: string, body: unknown) => affiliateApi.patch<T>(url, body).then((r) => r.data)

export const apiDelete = <T>(url: string) => affiliateApi.delete<T>(url).then((r) => r.data)
